import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { guarantee } from '../data/content';
export function Guarantee() {
  return <section className="w-full bg-night-900 py-16 md:py-24" data-id="element-77" data-mp="1o33u6h0ytshr">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-78" data-mp="223y4x6bhk5jl">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-2xl bg-night-700 ring-1 ring-gold-400/25" data-id="element-79" data-mp="1x4bravrqwna9">
          <ShieldCheckIcon className="h-10 w-10 text-gold-400" strokeWidth={1.25} aria-hidden="true" data-id="element-80" data-mp="19dzd535wpub8" />
        </span>

        <h2 className="mt-7 font-display text-[2rem] font-bold leading-tight tracking-tight text-ink md:text-[2.5rem]" data-id="element-81" data-mp="14gz3yjdrgbfw">
          {guarantee.title}
        </h2>

        <div className="mt-9 rounded-2xl bg-night-700 px-6 py-9 ring-1 ring-white/5 md:px-10" data-id="element-82" data-mp="1ee3t8s2wkn0x">
          <p className="text-lg leading-relaxed text-muted md:text-xl" data-id="element-83" data-mp="qnzqemxjgraz">{guarantee.body}</p>
          <p className="mt-6 font-display text-2xl font-bold tracking-tight text-gold-300 md:text-3xl" data-id="element-84" data-mp="lp6aknus4o7n">
            {guarantee.emphasis}
          </p>
          <p className="mt-3 text-lg font-semibold text-ink md:text-xl" data-id="element-85" data-mp="oyqe49mubxjo">{guarantee.closing}</p>
        </div>
      </div>
    </section>;
}